import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIBtnClose',
    props: {
        as: {},
        hover: { type: Boolean },
        active: { type: Boolean },
        theme: {},
        variant: {},
        sound: { type: [String, Boolean], default: "UI_SECONDARY_CLICK" }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_UIBtn = _resolveComponent("UIBtn");
            return (_openBlock(), _createBlock(_component_UIBtn, _mergeProps(props, {
                icon: "cross",
                appear: false
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createTextVNode(_toDisplayString(_ctx.$t("global.close")), 1)
                    ])
                ]),
                _: 3
            }, 16));
        };
    }
});
